module.exports = __webpack_public_path__ + "img/u3083.bbb93493.jpg";